<template>
  <div class="position-relative" id="subheader">
    <b-container fluid class="px-4">
      <b-row align-v="center" no-gutters class="amseu-header">
        <!-- Logo -->
        <b-col cols="auto" class="p-0">
          <div class="d-flex align-items-center text-decoration-none amseu-brand">
            <img
              :src="require('@/assets/img/logo/logo_amseu.svg')"
              alt="AMS"
              class="img img-fluid amseu-logo"
            />
            <span class="amseu-title d-none d-sm-flex flex-column ml-3">
              <span class="amseu-title-main">{{ translations[16261] }}</span>
              <span class="amseu-title-sub">{{ translations[16262] }}</span>
            </span>
          </div>
        </b-col>
        <!-- /Logo -->

        <!-- Cooperation -->
        <b-col cols="auto" class="d-none d-md-flex flex-column align-items-end ml-auto amseu-coop">
          <span class="amseu-coop-label">IN KOOPERATION MIT</span>
          <img
            :src="require('@/assets/img/logo/mini_logo_amseu.png')"
            alt="EURES"
            class="img img-fluid amseu-coop-logo mt-1"
          />
        </b-col>
        <!-- /Cooperation -->

        <b-col cols="auto" class="d-flex align-items-center ml-auto ml-md-3">
          <language-header />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class InformationNavigation extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }
}
</script>
<style scoped lang="scss">
.amseu-header {
  min-height: 4.5rem;
}

.amseu-logo {
  max-height: 3.25rem;
  width: auto;
}

.amseu-title-main {
  color: #ed1639;
  font-weight: 700;
  font-size: 1.375rem;
  line-height: 1.2;
}

.amseu-title-sub {
  color: #4d606a;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.2;
}

.amseu-coop {
  &-label {
    color: #5a6b75;
    font-weight: 700;
    font-size: 10px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  &-logo {
    max-height: 2.25rem;
    width: auto;
  }
}

@media (max-width: 1199.98px) {
  .amseu-title-main {
    font-size: 1.125rem;
  }
  .amseu-title-sub {
    font-size: 0.8125rem;
  }
}
</style>
